import * as Sentry from '@sentry/nuxt'

// Get runtime config to access environment variables the Nuxt way
const config = useRuntimeConfig()

// Skip Sentry initialization during Cypress tests
if (typeof window !== 'undefined' && window.Cypress) {
  // Do not initialize Sentry during tests
} else if (config.public.sentryDsn) {
  Sentry.init({
    dsn: config.public.sentryDsn,
    environment: process.env.NODE_ENV || 'development',

    // Performance monitoring
    tracesSampleRate: process.env.NODE_ENV === 'production' ? 0.1 : 1.0,

    // Session replay
    replaysSessionSampleRate: process.env.NODE_ENV === 'production' ? 0.1 : 1.0,
    replaysOnErrorSampleRate: 1.0,

    // Additional configuration
    beforeSend(event) {
      // Filter out development errors if needed
      if (process.env.NODE_ENV === 'development') {
        console.log('Sentry event:', event)
      }
      return event
    },

    // Set initial context
    initialScope: {
      tags: {
        component: 'nuxt-frontend'
      }
    }
  })
}
